/*
 * @Descripttion: 接口基本配置
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-04-17 15:07:49
 */
const base = {
  request: "",
  upload: "",
  video: "",
  preRequest: "/cm-api",
  bsRequest: "/bs-api",
  openApi:"/open_api"
};
switch (process.env.NODE_ENV) {
  case "development":
    base.request = base.preRequest;
    base.bsRequest = base.bsRequest;
    base.upload = "https://test-img4.nongji360.com";
    base.video = "https://datasp1.nongji360.com";
    base.openApi = base.openApi
    break;
  case "test":
    base.request = "https://test-cm-api.datian360.com";
    base.upload = "https://test-img4.nongji360.com"; 
    base.video = "http://datasp1.nongji360.mobi";
    base.video = "http://datasp1.nongji360.com";
    break;
  case "production":
    base.request = "https://m-ai.nongji360.com/prod_api";
    base.bsRequest = "https://bs.datian360.com";
    base.upload = "https://img4.nongji360.com";
    base.video = "https://datasp1.nongji360.com";
    break;
}
export { base };
